module.exports = {
    cognitoUserPoolClientId: '5j04afk2qjidk40q9reqm3v02r',
    cognitoUserPoolId: 'us-east-1_7DXsZWUIk',
    environment: 'prod',
    lowerEnvironment: 'staging',
    restApiEndpoint: 'https://bovcdr8azf.execute-api.us-east-1.amazonaws.com/prod',
    restApiName: 'prod-dsco-ship-codes-ApiStack-1A1ZBPJDOUG9V'
}
